/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOrderBillItemModel as DigiworkMaitreDPosDtoOrderDeleteOrderBillItemModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/delete-order-bill-item-model';

export interface DeleteOrderBillItem$Params {
      body?: DigiworkMaitreDPosDtoOrderDeleteOrderBillItemModel
}

export function deleteOrderBillItem(http: HttpClient, rootUrl: string, params?: DeleteOrderBillItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteOrderBillItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteOrderBillItem.PATH = '/api/wtr/OrderBill/deleteorderbillitem';
